import {
  getSlideInPanelAnchorLocationLabel,
  SlideInPanelAnchorLocation,
} from "@redotech/redo-storefront-common/slide-in-panel-anchor-location";
import { assertNever } from "@redotech/util/type";

export const SaveForLaterSlideInPanelAnchorLocation = [
  SlideInPanelAnchorLocation.BOTTOM_LEFT,
  SlideInPanelAnchorLocation.BOTTOM_RIGHT,
] as const;
export type SaveForLaterSlideInPanelAnchorLocation =
  (typeof SaveForLaterSlideInPanelAnchorLocation)[number];

export const getSaveForLaterSlideInPanelAnchorLocation = (
  anchorLocation: SaveForLaterSlideInPanelAnchorLocation,
) => {
  switch (anchorLocation) {
    case SlideInPanelAnchorLocation.BOTTOM_LEFT:
      return getSlideInPanelAnchorLocationLabel(
        SlideInPanelAnchorLocation.BOTTOM_LEFT,
      );
    case SlideInPanelAnchorLocation.BOTTOM_RIGHT:
      return getSlideInPanelAnchorLocationLabel(
        SlideInPanelAnchorLocation.BOTTOM_RIGHT,
      );
    default:
      assertNever(anchorLocation);
  }
};

export const DEFAULT_SAVE_FOR_LATER_PANEL_ANCHOR_LOCATION: SaveForLaterSlideInPanelAnchorLocation =
  SlideInPanelAnchorLocation.BOTTOM_LEFT;
